import React, { Component } from 'react'
import CategoryHeader from '../Header'
import PrioritiesTable from './PlaybookPrioritiesTable'
import OnboardingHeader from './OnboardingHeader'
import { savePriorities } from '../api/playbooks'
import ACCESS from 'utils/Access'
import { captureException } from 'utils/SentryHelpers'

import SubNav from 'components/shared/Subnav'
import SUB_NAV_NODES from '../navigation'

let foreverDismissOnboarding = false
try {
  foreverDismissOnboarding = window.localStorage.getItem('dismiss-playbook-prioritization-onboarding')
} catch(e) {}

class PlaybookPrioritiesWrapper extends Component {
  constructor(props) {

    super(props)

    this.state = {
      priorityList: [],
      initialLoad: true,
      showOnboarding: !JSON.parse(foreverDismissOnboarding)
    }

  }

  dismissOnboarding = () => {
    this.setState({
      showOnboarding: false
    })
  }

  dismissOnboardingForever = () => {
    window.localStorage.setItem('dismiss-playbook-prioritization-onboarding', true)
    this.dismissOnboarding()
  }

  setData = (idArray, initial) => {
    this.setState({ priorityList: idArray, initialLoad: initial })
  }

  saveData = async () => {
    const { priorityList } = this.state
    this.setState({ loading: true })
    try {
      await savePriorities(priorityList)
      setTimeout(() => {
        window.open('/playbooks', '_self')
      }, 1000)
    } catch(err) {
      captureException(err)
    }
  }

  render() {
    const { initialLoad, loading, showOnboarding } = this.state
    const showNewSubNav = ACCESS.isAdmin()

    return (
      <div className="playbooks-list-wrapper">
        {showNewSubNav && (
          <SubNav
            title="Playbooks"
            open={false}
            nodes={SUB_NAV_NODES()}
          />
        )}

        <div className="playbooks-list">
          <CategoryHeader category={'Chat Playbooks'} heading={'Set Priority'} saveHandler={this.saveData} disableSave={initialLoad} loading={loading}/>
          <OnboardingHeader
            show={showOnboarding}
            onHide={this.dismissOnboarding}
            onHideForever={this.dismissOnboardingForever}
          />
          <PrioritiesTable storeData={this.setData}/>
        </div>
      </div>
    )
  }
}

export default PlaybookPrioritiesWrapper



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/Prioritize/index.js